import classNames from 'classnames/bind';
import React, { useCallback, useState } from 'react';

import Button, { ButtonProps } from '..';
import styles from './SelectorButton.scss';

const cx = classNames.bind(styles);

export const Selection = ({
  children,
  id,
  setActive,
  onClick,
  ...props
}: {
  id?: string;
  setActive?: (e: React.MouseEvent, id: string) => void;
} & ButtonProps) => {
  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (onClick) onClick(e);
      if (setActive && id !== undefined) setActive(e, id);
    },
    [onClick, setActive, id]
  );

  return (
    // @ts-expect-error
    <li {...props} onClick={handleClick}>
      {children}
    </li>
  );
};

const SelectorButton = ({
  className,
  children,
  options,
  value = 0,
  ...props
}: { value: any; options?: any } & ButtonProps) => {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);

  const toggleVisibility = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(!visible);
  };

  const handleSetActive = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(false);
    setActive(id);
  };

  if (!children || !Array.isArray(children)) return null;

  console.log('active', active, children);

  return children?.map((activeButton: React.ReactElement<any>, id) =>
    id === active ? (
      <Button
        {...props}
        {...activeButton?.props}
        className={cx('SelectorButton', className)}
      >
        {activeButton?.props.children}

        <span
          className={cx('SelectorButton__Switch')}
          onClick={toggleVisibility}
        >
          <i className="ion-ios-arrow-down" />
        </span>
        {visible && (
          <ul className={cx('SelectorButton__List')}>
            {React.Children.map(children, (child, id) =>
              React.cloneElement(child, {
                id,
                setActive: (e) => handleSetActive(e, id),
              })
            )}
          </ul>
        )}
      </Button>
    ) : null
  );
};

export default SelectorButton;
